
import LolePicture from '~/components/picture/lole-picture'
import LoleH2 from '~/components/text/lole-h2'
import LoleP from '~/components/text/lole-p'
export default {
  name: 'LoleStaticPageCard',
  components: {
    LolePicture,
    LoleH2,
    LoleP,
  },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  beforeMount() {
    window.addEventListener('scroll', this.handleScrollAnimation)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScrollAnimation)
  },
  methods: {
    elementInView(dividend = 1) {
      const elementTop = this.$el.getBoundingClientRect().top
      return (
        elementTop <=
        (window.innerHeight || document.documentElement.clientHeight) / dividend
      )
    },
    elementOutOfView() {
      const elementTop = this.$el.getBoundingClientRect().top

      return (
        elementTop >
        (window.innerHeight || document.documentElement.clientHeight)
      )
    },

    handleScrollAnimation() {
      if (this.elementInView(1.25)) {
        this.$el.classList.add('enter')
      }

      if (this.$el.classList.contains('enter')) {
        window.removeEventListener('scroll', this.handleScrollAnimation)
      }
    },
  },
}
